import { Link } from "react-router-dom";
import routeNames, { AppRoutes } from "../../../routing/routeNames";
import { Dropdown, MenuProps } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { useDialog } from "../../components/dialog/use-dialog";
import { useDeletePipelineMutation } from "../api/api";
import { Message } from "../../../utility/notifications/Message";

interface Props {
	id: number;
}
function PipelineActionButton({ id }: Props) {
	const [deletePipeline, { isLoading }] = useDeletePipelineMutation();

	const handleDeletePipeline = async (pipelineId: number) => {
		const result = await Message('Confirm', "Are you sure to delete the pipeline?", 'warning');
		if (result.isConfirmed) {
			await deletePipeline({ pipelineId });
		}
	}

	const { onOpen: openUpdatePipelineDialog } = useDialog('biHubPipelineUpdate');
	const { onOpen: openSchedulePipelineDialog } = useDialog('biHubPipelineSchedule');

	const items: MenuProps['items'] = [
		{
			key: '1',
			label: "Edit",
			onClick: () => openUpdatePipelineDialog({ tenantName: "", id }),
		},
		{
			key: '2',
			label: "Schedule",
			onClick: () => openSchedulePipelineDialog({ id: id }),
		},
		{
			key: '3',
			label: (
				<Link to={`${AppRoutes.pipelinePage.path}/${id}`}>
					Refresh / Move Steps
				</Link>
			),
		},
		{
			key: '4',
			label: "Delete",
			onClick: () => handleDeletePipeline(id),
		}
	];
	return (
		<Dropdown menu={{ items }} placement='bottomRight'>
			<EllipsisOutlined style={{ fontSize: 30 }} />
		</Dropdown>
	);
};

export { PipelineActionButton };
